import { RangeSlider } from "lib/miolo";
import { useState } from "react";
import { connectRange } from "react-instantsearch-dom";
import * as palette from "../../palette";

type TRefineArguments = {
  min?: number;
  max?: number;
};

interface IConnectedSliderRangeProps {
  label: string;
  accessibilityLabels: [string, string];
  refine: (refinement: TRefineArguments) => void;
  currentRefinement: {
    min?: number;
    max?: number;
  };
}

function ConnectedSliderRange({ label, accessibilityLabels, refine, currentRefinement }: IConnectedSliderRangeProps) {
  const [willUpdateToValues, setWillUpdateToValues] = useState<ReadonlyArray<number> | null>(null);

  return (
    <div
      css={{
        display: "grid",
        gridRowGap: 20,
      }}
    >
      <div
        css={{
          display: "flex",
          justifyContent: "space-between",
          color: palette.mariner,
          fontWeight: "bold",
          fontSize: 14,
          letterSpacing: 1,
        }}
      >
        <strong
          css={{
            fontWeight: 700,
          }}
        >
          {label}
        </strong>

        {willUpdateToValues ? (
          <strong
            css={{
              fontWeight: 700,
              color: palette.baliHai,
            }}
          >
            {willUpdateToValues[0] || 0}% — {willUpdateToValues[1] || 100}%
          </strong>
        ) : (
          <strong
            css={{
              fontWeight: 700,
            }}
          >
            {currentRefinement.min || 0}% — {currentRefinement.max || 100}%
          </strong>
        )}
      </div>

      <RangeSlider
        domain={[0, 100]}
        values={[currentRefinement.min || 0, currentRefinement.max || 100]}
        labels={accessibilityLabels}
        onUpdate={setWillUpdateToValues}
        onChange={([min, max]) => {
          setWillUpdateToValues(null);

          if (min === 0 && max === 100) {
            refine({
              min: undefined,
              max: undefined,
            });
          } else {
            refine({
              min,
              max,
            });
          }
        }}
      />
    </div>
  );
}

export default connectRange(ConnectedSliderRange);
